<div class="balao-linha" [class.balao-linha-cliente]="ehCliente" [class.balao-linha-sistema]="!ehCliente"
    [class.balao-linha-acoes]="menuReacao() !== null" [class.balao-linha-com-reacao]="!!mensagem.reacao"
    [class.balao-linha-arrastando]="arraste() > 0"
    [attr.data-msg-id]="mensagem.id" [attr.data-meta-id]="mensagem.metaId">
  @if (arraste() > 0) {
    <span class="balao-arraste-icone" @surgir [style.opacity]="progressoArraste" [style.transform]="'scale(' + (0.6 + progressoArraste * 0.4) + ')'">
      <img src="./assets/icones/redesign/modulos/chat/components-message/reply-primary.svg" alt="" />
    </span>
  }
  <div class="balao" cdkOverlayOrigin #origemBalao="cdkOverlayOrigin"
      [style.transform]="arraste() > 0 ? 'translateX(' + arraste() + 'px)' : null" [class.balao-cliente]="ehCliente" [class.balao-sistema]="!ehCliente" [class.balao-com-midia]="ehMidia" [class.balao-com-arquivo]="temArquivo"
      [class.balao-figurinha]="ehFigurinha"
      [class.balao-preview]="isTemplatePreview" [class.balao-enviando]="mensagem.enviando"
      [class.balao-falhou]="enviadoPeloSistema && statusEnvio === 'FAILED'">
    @if (mensagem.enviando && mensagem.isMensagemTemp && ehMidia && !mensagem.isTemplate) {
      <span class="balao-upload"><span class="balao-upload-spinner"></span></span>
    }
    @if (mensagem.mensagemResposta; as resposta) {
      <div class="balao-resposta" [class.balao-resposta-cliente]="resposta.sendBy === 'CLIENTE'" role="button" tabindex="0"
          title="Ir para a mensagem" (click)="clicarResposta(resposta, $event)" (keydown.enter)="clicarResposta(resposta, $event)">
        <span class="balao-resposta-autor">{{ resposta.sendBy === 'CLIENTE' ? 'Cliente' : 'Você' }}</span>
        <span class="balao-resposta-texto">{{ resumoResposta(resposta) }}</span>
      </div>
    }

    @if (temArquivo && ehFigurinha) {
      @if (imagemComErro()) {
        <div class="balao-imagem-erro balao-figurinha-erro">
          <mat-icon>image_not_supported</mat-icon>
          <span>Figurinha indisponível</span>
        </div>
      } @else {
        <img class="balao-figurinha-imagem" alt="Figurinha" role="button" tabindex="0" loading="lazy" draggable="false"
            [src]="getSafeUrl(mensagem.urlImage)"
            (error)="imagemComErro.set(true)" (click)="clicarMidia($event)" (keydown.enter)="clicarMidia($event)" />
      }
    } @else if (temArquivo && verificarImagem(mensagem)) {
      @if (imagemComErro()) {
        <div class="balao-imagem-erro">
          <mat-icon>image_not_supported</mat-icon>
          <span>Imagem indisponível</span>
        </div>
      } @else {
        <img class="balao-imagem" alt="Imagem da mensagem"
            role="button" tabindex="0" loading="lazy" [src]="getSafeUrl(mensagem.urlImage)"
            (error)="imagemComErro.set(true)" (click)="clicarMidia($event)" (keydown.enter)="clicarMidia($event)" />
      }
    } @else if (temArquivo && verificarVideo(mensagem)) {
      <div class="balao-video" role="button" tabindex="0" aria-label="Abrir vídeo" (click)="clicarMidia($event)" (keydown.enter)="clicarMidia($event)">
        <video class="balao-video-capa" preload="metadata" muted playsinline [src]="urlCapaVideo(mensagem.urlImage)"
              (loadedmetadata)="aoCarregarVideo($event)"></video>
        <span class="balao-video-play">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>
        </span>
        @if (duracaoVideo()) {
          <span class="balao-video-duracao">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h11v10H4zM15 10.5l5-3v9l-5-3z" fill="currentColor"/></svg>
            {{ duracaoVideo() }}
          </span>
        }
      </div>
    } @else if (temArquivo && (verificarPdf(mensagem) || verificarTipoArquivoDowload(mensagem))) {
      <div class="balao-arquivo" role="button" tabindex="0" title="Visualizar arquivo"
          (click)="clicarMidia($event)" (keydown.enter)="clicarMidia($event)">
        <span class="chat-tipo-arquivo balao-arquivo-tipo" [style.border-color]="infoArquivo.cor" [matTooltip]="infoArquivo.rotulo">
          <img [src]="infoArquivo.icone" [alt]="infoArquivo.rotulo" />
        </span>
        <span class="balao-arquivo-nome">{{ extrairNomeArquivo(mensagem.urlImage) }}</span>
        <button type="button" class="balao-arquivo-download" aria-label="Baixar arquivo" matTooltip="Baixar" (click)="baixar($event)">
          <img src="./assets/icones/redesign/utils/dowload-white.svg" alt="" />
        </button>
      </div>
    } @else if (temArquivo && verificarAudio(mensagem)) {
      <app-player-audio class="balao-audio" [src]="mensagem.urlImage" [cliente]="ehCliente" (terminou)="audioTerminou.emit(mensagem)"></app-player-audio>
    }

    @if (mensagem.isTemplate && mensagem.mensagemCabecalho) {
      <span class="chat-balao-cabecalho">{{ mensagem.mensagemCabecalho }}</span>
    }

    @if (mensagem.mensagem) {
      <div class="balao-texto-bloco">
        <span class="balao-texto" [innerHTML]="htmlTexto"></span>
        @if (textoLongo && !textoExpandido()) {
          <button type="button" class="balao-ler-mais" (click)="expandirTexto($event)">Ler mais</button>
        }
        @if (horaNoTexto) {
          <span class="balao-rodape-espaco" aria-hidden="true" [style.width.px]="larguraRodape"></span>
        }
      </div>
    }

    @if (mensagem.opcoes && mensagem.opcoes.length > 0) {
      <div class="balao-opcoes">
        @for (opcao of mensagem.opcoes; track opcao.titulo) {
          <div class="balao-opcao">
            <span class="balao-opcao-titulo">{{ opcao.titulo }}</span>
            @if (opcao.descricao?.length) {
              <span class="balao-opcao-descricao">{{ opcao.descricao }}</span>
            }
          </div>
        }
      </div>
    }

    @if (mensagem.isTemplate && mensagem.mensagemRodape) {
      <span class="chat-balao-rodape-texto">{{ mensagem.mensagemRodape }}</span>
    }

    @if (temBotoesTemplate) {
      <div class="chat-balao-botoes">
        @for (botao of mensagem.botoes; track $index) {
          <span class="chat-balao-botao" [matTooltip]="botao.valor ?? ''" [matTooltipDisabled]="!botao.valor">
            <mat-icon>{{ iconeBotaoTemplate(botao.tipo) }}</mat-icon>
            {{ botao.titulo }}
          </span>
        }
      </div>
    }

    <div class="balao-rodape" [class.balao-rodape-flutuante]="horaNoTexto || horaNaLinhaAudio" [class.balao-rodape-audio]="horaNaLinhaAudio" [class.balao-rodape-sobre-midia]="horaSobreImagem"
        [class.balao-rodape-figurinha]="ehFigurinha && !mensagem.mensagem">
      @if (!isTemplatePreview && (mensagem.disparoId || mensagem.isTemplate)) {
        <button type="button" class="balao-badge-tipo" [class.balao-badge-disparo]="mensagem.disparoId"
                [matTooltip]="mensagem.disparoId ? 'Mensagem de disparo' : 'Mensagem de template'"
                (click)="abrirModalInfoMensagem(mensagem.disparoId ? 1 : 2); $event.stopPropagation()">
          {{ mensagem.disparoId ? 'D' : 'T' }}
        </button>
      }
      <span class="balao-hora">{{ mensagem.date | date: 'HH:mm' }}</span>
      @if (mensagem.enviando) {
        <mat-icon class="balao-status" matTooltip="Enviando...">schedule</mat-icon>
      } @else if (enviadoPeloSistema) {
        @if (statusEnvio === 'FAILED') {
          <mat-icon class="balao-status balao-status-erro" role="button"
                    [matTooltip]="'Erro ao enviar: ' + (mensagem.erroMensagem ?? '') + ' — clique para reenviar'"
                    (click)="enviarNovamenteFunc(mensagem)">error</mat-icon>
        } @else {
          <app-status-mensagem class="balao-status" [status]="statusEnvio"></app-status-mensagem>
        }
      }
    </div>

    @if (mensagem.reacao) {
      <button type="button" class="balao-reacao" @pop cdkOverlayOrigin #origemReacao="cdkOverlayOrigin"
              [attr.aria-label]="'Reação ' + mensagem.reacao + ' — ver detalhes'"
              (click)="abrirMenuReacao('detalhes', $event)">{{ mensagem.reacao }}</button>

      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origemReacao"
                  [cdkConnectedOverlayOpen]="menuReacao() === 'detalhes'" [cdkConnectedOverlayPositions]="posicoesDetalhes"
                  [cdkConnectedOverlayPush]="true" cdkConnectedOverlayPanelClass="chat-redesign"
                  (overlayOutsideClick)="fecharMenuReacao()" (overlayKeydown)="$event.key === 'Escape' && fecharMenuReacao()"
                  (detach)="fecharMenuReacao()">
        <app-menu-reacao @pop modo="detalhes" [mensagem]="mensagem" [podeReagir]="podeReagir"
                        [nomeContato]="nomeContato" [fotoContato]="fotoContato"
                        (escolher)="escolherReacao($event)" (remover)="removerReacao()" (redimensionou)="reposicionarMenuReacao()"></app-menu-reacao>
      </ng-template>
    }
  </div>

  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origemBalao"
              [cdkConnectedOverlayOpen]="menuReacao() === 'seletor'" [cdkConnectedOverlayPositions]="posicoesMenu"
              [cdkConnectedOverlayPush]="true" cdkConnectedOverlayPanelClass="chat-redesign"
              (overlayOutsideClick)="fecharMenuReacao()" (overlayKeydown)="$event.key === 'Escape' && fecharMenuReacao()"
              (detach)="fecharMenuReacao()">
    <app-menu-reacao @pop modo="seletor" [mensagem]="mensagem" [podeReagir]="podeReagir"
                    (escolher)="escolherReacao($event)" (redimensionou)="reposicionarMenuReacao()"></app-menu-reacao>
  </ng-template>

  <div class="balao-acoes">
    @if (podeReagir) {
      <button type="button" class="balao-btn-acao balao-btn-reagir" [class.balao-btn-acao-ativo]="menuReacao() === 'seletor'"
              aria-label="Reagir à mensagem" matTooltip="Reagir" (click)="abrirMenuReacao('seletor', $event)">
        <span class="chat-icone-duplo" [class.chat-icone-duplo-ligado]="menuReacao() === 'seletor'"><img src="./assets/icones/redesign/modulos/chat/components-message/reaction.svg" alt="" class="chat-icone-base" /><img src="./assets/icones/redesign/modulos/chat/components-message/reaction-primary.svg" alt="" class="chat-icone-ativo" /></span>
      </button>
    }
    @if (podeResponder && mensagem.metaId) {
      <button type="button" class="balao-btn-acao balao-btn-responder" aria-label="Responder mensagem" matTooltip="Responder" (click)="clicarResponder()">
        <span class="chat-icone-duplo"><img src="./assets/icones/redesign/modulos/chat/components-message/reply.svg" alt="" class="chat-icone-base" /><img src="./assets/icones/redesign/modulos/chat/components-message/reply-primary.svg" alt="" class="chat-icone-ativo" /></span>
      </button>
    }
  </div>
</div>
